import $ from 'jquery'

$(document).ready(function () {

  
    $(window).scroll(function () {
      if ($(this).scrollTop() > 300) {
        $(".navbar-inverse .navbar-nav>li>a").css('color', '#212529');
        $(".navbar-inverse .navbar-nav>li>a").css('fontWeight', '700');           
        $(window).resize(function() {
            if($(window).width()>=768) { 
           
              $("#opciones-menu").css('visibility', 'visible');
            }else{
              $("#opciones-menu").css('visibility', 'hidden');
            }
        });

      }else{ 
        $(".navbar-inverse .navbar-nav>li>a").css('color', 'white');
        $(window).resize(function() {
          if($(window).width() >= 768) { 
            $("#opciones-menu").css('visibility', 'visible');
          }else{
            $("#opciones-menu").css('visibility', 'hidden');
          }
      });
      
      }
    
  });

 




  $('#info').click(function (e) {
    $('.factura-menu').css('height','290%');
  });
  $('#cerrar').click(function (e) {
    $('.factura-menu').css('height','250px');
  });
  $('#contactos-menu').click(function (e) {
    $('.factura-menu').css('height','250px');
  });


/* 
  $('#btn-sabermas').click(function (e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 650
    }, 1000);
    return false;
  });

  $('#empesar-tenemos').click(function (e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 1300
    }, 1000);
    return false;
  });

  $('#button').click(function (e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 2000
    }, 1000);
    return false;
  });
  $('#modulos').click(function (e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 8500
    }, 1);
    return false;
  });
  
  $('#button-contactenos').click(function (e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 8100
    }, 2000);
    return false;
  });

  $('#btn-contac').click(function (e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 8100
    }, 2000);
    return false;
  });


  $('#button-nosotros').click(function (e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 6520
    }, 2000);
    return false;
  });
  $('#button-manuales').click(function (e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 5650
    }, 2000);
    return false;
  });



  $("#button-productos").click(function (e) {
    $('body,html').animate({
      scrollTop: '#id-productos'
    }, 1000);
    return false;
  });

 

  $('#button-inicio').click(function (e) {
    $(".inicio").css("borderBottom", "2px solid dodgerblue");
    $(".producto").css('borderBottom', "none");
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });

  $('#mas-productos').click(function (e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 3460
    }, 1000);
    return false;
  });
  

 */


 // icono button subir 
  $(window).scroll(function () {
    if ($(this).scrollTop() > 300) {
      $("#boton-subir").slideDown(300);
    } else {
      $("#boton-subir").slideUp(300);
    }
  });

  
  $("#boton-subir").on('click', function (e) {
    e.preventDefault();
    $("body,html").animate({
      scrollTop: 0
    }, 1000);
    return false;
  }); 


  $(window).scroll(function () {
    if ($(this).scrollTop() > 300) {
      $("#menu-id").css('backgroundColor', 'white');
      $("#menu-id").css('borderBottom', '1px solid rgba(33,37,41,.1)');
      $(".navbar-inverse .navbar-nav>li>a").css('color', '#212529');
      $(".navbar-inverse .navbar-nav>li>a").css('fontWeight', '700');
      $(".navbar-inverse .navbar-brand").css('color', 'rgb(25, 118, 210)');
    } else {
      $("#menu-id").css('backgroundColor', '#252525');
      $("#menu-id").css('borderBottom', '0px');
      $(".navbar-inverse .navbar-nav>li>a").css('color', 'white');
      $(".navbar-inverse .navbar-brand").css('color', 'white');
      $('#indicator').css('visibility', 'visible');
    }
  });

  var contar =0;
 $('#menu-responsi-id').click(function (e) {
  if ($(this).scrollTop() <300) {
    $(".navbar-inverse .navbar-nav>li>a").css('color', 'white');
  }
    contar+=1;

    if(contar==1){
      $("#menu-id").css('height', '270px');
      $("#menu-id").css('backgroundColor', 'white');
      $("#opciones-menu").css('visibility', 'visible');
      $(".navbar-inverse .navbar-nav>li>a").css('color', '#212529');
      $(".navbar-inverse .navbar-brand").css('color', 'rgb(25, 118, 210)');
      $(window).scroll(function () {
        if ($(this).scrollTop() <= 300) {
          $("#menu-id").css('height', '270px');
          $("#menu-id").css('backgroundColor', 'white');
          $(".navbar-inverse .navbar-nav>li>a").css('color', '#212529');
          $(".navbar-inverse .navbar-brand").css('color', 'rgb(25, 118, 210)');
        }
        if($(this).scrollTop() >= 200 && $(this).scrollTop() <= 300){
          $('#indicator').css('visibility', 'hidden');
        }
      });
    }else if(contar == 2){
        $("#menu-id").css('height', '60px');
        $("#menu-id").css('backgroundColor', '#252525');
        $("#opciones-menu").css('visibility', 'hidden');
        $(".navbar-inverse .navbar-brand").css('color', 'white');
        $(".navbar-inverse .navbar-nav>li>a").css('color', 'white');

        $(window).scroll(function () {
          if ($(this).scrollTop() <= 300) {
            $("#menu-id").css('height', '60px');
            $("#menu-id").css('backgroundColor', '#252525');
            $(".navbar-inverse .navbar-brand").css('color', 'white');
          }
          
        });
        contar = 0;
    }


  }); 
 

});


// WEBPACK FOOTER //
// ./src/js/Eventoclick.js